<template>
  <div>
    <IncomeList title="其他" :pay-channel="'OTHER'" />
  </div>
</template>
<script>
import IncomeList from '../IncomeList'
export default {
  components: {
    IncomeList,
  },
}
</script>
